
import request from '@/util/request'

export function groupList() {
    return request({
        url: '/api/v1/account/department/list',
        method: 'get',
    })
}

export function groupAll() {
    return request({
        url: '/api/v1/account/department/all',
        method: 'get',
    })
}

export function groupCreate(data) {
    return request({
        url: '/api/v1/account/department/create',
        method: 'post',
        data
    })
}

export function departmentBindUser(data) {
    return request({
        url: '/api/v1/account/department/bindUser',
        method: 'post',
        data
    })
}

export function groupUserUnion(params) {
    return request({
        url: '/api/v1/account/department/user/union',
        method: 'get',
        params
    })
}

export function groupUserList(params) {
    return request({
        url: '/api/v1/account/department/userList',
        method: 'get',
        params
    })
}

export function groupUserDelete(params) {
    return request({
        url: '/api/v1/account/department/userDelete',
        method: 'get',
        params
    })
}

export function departmentUpdateName(data) {
  return request({
    url: `/api/v1/account/department/update`,
    method: 'POST',
    data,
  })
}

export function departmentDelete(params) {
  return request({
    url: `/api/v1/account/department/delete`,
    method: 'GET',
    params,
  })
}
